import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 80%;
  height: 100%;
  text-align: center;

  .ant-avatar-group {
    align-items: center;
  }
`;

export const NoCommentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  color: ${({ theme }) => theme.colors.black7};
  text-align: center;
  &:first-child {
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
  }
  &:last-child {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }
`;

export const BoldWrapper = styled.span`
  font-weight: 600;
`;
